module.exports = __webpack_public_path__ + "img/tiaomakuaishu05-450.6a3a5f80.png";